
  import * as ipxStaticRuntime$nLh9U9QNqq5a_VQj_45TQ6YeNGveSq52We7VyfXBLx6Pk from '/home/runner/work/seed/seed/node_modules/@nuxt/image/dist/runtime/providers/ipxStatic'
  
  export const imageOptions = {
    ...{
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipxStatic",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
},
    providers: {
        ['ipxStatic']: { provider: ipxStaticRuntime$nLh9U9QNqq5a_VQj_45TQ6YeNGveSq52We7VyfXBLx6Pk, defaults: {} }
    }
  }
